import React, { ReactNode } from "react"
import { Modal } from "react-bootstrap"

// other

// React

export type TModalTypes = {
  isShow: boolean
  title?: string | ReactNode
  setIsShow: (value: boolean) => unknown
  size?: "sm" | "lg" | "xl"
  dialogClassName?: string
  isDisabledCloseButton?: boolean
  isAnimation?: boolean
}

/**
 * モーダル
 */
export const ModalOuter: React.FC<TModalTypes & { footer?: ReactNode }> = ({
  isShow,
  setIsShow,
  children,
  isAnimation = true,
  ...props
}) => {
  /**
   * モーダルダイアログ非表示時のイベントハンドラ
   *
   */
  const onHideModal = () => {
    setIsShow(false)
  }

  return (
    <Modal
      {...props}
      size={props.size ?? "xl"}
      show={isShow}
      onHide={() => onHideModal()}
      animation={isAnimation}
      dialogClassName={props.dialogClassName ?? "popupMenu"}
      backdrop="static"
      keyboard={false}
      aria-labelledby="contained-modal-title-vcenter"
      centered>
      <Modal.Body>{children}</Modal.Body>
    </Modal>
  )
}
